/**
 * Vue-Storage
 *
 * includes:
 * - global mixin
 * - directive
 * - helper
 *
 */
import Manager from './manager'
import mixin from './mixin'
import vClassState from './v-class-state'
import vVisibleState from './v-visible-state'

export default {
  install(Vue, options) {
    const storage = new Manager()

    Object.defineProperty(Vue, 'Storage', {
      writable: false,
      value: storage
    })
    Object.defineProperty(Vue.prototype, '$storage', {
      writable: false,
      value: storage
    })

    Vue.mixin(mixin)

    Vue.directive('class-state', vClassState)
    Vue.directive('visible-state', vVisibleState)
  }
}
